import KohortDetails from './KohortDetails';

export default KohortDetails;
